<template>
    <div class="col-12">
      <div class="search-padd">
        <div class="col-12 override-padding">
          <div class="crm_admin_heading col-12 text-align-center">Select Accounts to Activate</div>        
        </div>
        <div style="clear: both;"></div>
       
          <div class="crm_admin_field_lists col-12 unit-wrapper">
            <div v-for="(license, lindex) in licenseAvailable">
              {{ license.unitType }}: {{ license.units }}
             </div>
             <div>{{ licenseApplied }} Licenses Applied</div> 
          </div>
         
          <div style="clear: both;"></div>
        
        <div class="col-12 override-padding" v-if="enterprise_accounts.length == 0">
          No orders found
        </div>
        <div class="col-12 override-padding mt-4">
           <div class="crm_admin_heading account_heading_1 text-left"><input type="checkbox" /></div>
          <div class="crm_admin_heading account_heading_2 text-left">Account Name</div>
          <div class="crm_admin_heading account_heading_3 text-left">Address</div>
          <div class="crm_admin_heading account_heading_4 text-left">City</div>
          <div class="crm_admin_heading account_heading_5 text-left">State</div>
          <div class="crm_admin_heading account_heading_6 text-left">Postal Code</div>
          <div class="crm_admin_heading account_heading_7 text-left">Phone</div>
          <div class="crm_admin_heading account_heading_8 text-left">Unit Type</div>
          <div class="crm_admin_heading account_heading_9 text-center">Status</div>
          <div class="crm_admin_heading account_heading_10 text-left">Exp</div>
        </div>
        
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div class="accounts_items unit-wrapper" v-if="enterprise_accounts.length > 0">
          <div v-for="(account, index) in enterprise_accounts">
             <div class="crm_admin_field_lists account_heading_1 text-left"><input :value="account.accountId" 
                  :id="account.accountId" 
                  type="checkbox" 
                  :checked="account.checked"  /></div>
            <div class="crm_admin_field_lists account_heading_2 text-left">
                  {{ account.accountName }}
              </div>
              <div class="crm_admin_field_lists account_heading_3 text-left">
                {{ account.address }}
              </div>
              <div class="crm_admin_field_lists account_heading_4 text-left">
                  {{ account.city }}
              </div>
              <div class="crm_admin_field_lists account_heading_5 text-left">
                {{ account.state }}
              </div>
              <div class="crm_admin_field_lists account_heading_6 text-left">
                {{ account.zip }}
              </div>
              <div class="crm_admin_field_lists account_heading_7 text-left">
                {{ account.phoneNumber + " " + account.phoneExt }}
              </div>
              <div class="crm_admin_field_lists account_heading_8 text-center link_name font-weight-bold">
                  <b-form-select class="custom-select billingInput"
                v-bind:id="account.accountId+ '_unittype'"
                 :options="unitType"
                name="subscription"
                v-model="account.unitType"
              ></b-form-select>
              </div>
              <div :class="'crm_admin_field_lists account_heading_9 text-center font-weight-bold ' + getStatusColor(account.status)">
                {{ account.status }}
              </div>
              <div class="crm_admin_field_lists account_heading_10 text-left">
                {{ account.expirationDate }}
              </div>

            <div style="clear: both;"></div>
          </div>
        </div>
        
        <div style="clear: both;" class="margin-bottom-10"></div>
        <button class="btn btn-primary customBtn mt-3" @click="getSelectedAccountLicense">Process</button>
        
      </div>
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import CheckReceivedOrderUpdateModal from './check_received_order_update_modal.vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

export default {
      props: ['accountId'],
      data() {
        return {
          enterprise_accounts: [],
          totalOrders: [],
          loading: false,
          isCheckOrderUpdateModal: false,
          checkReceived: '',
          checkNumber: '',
          updateOrderId: '',
          unitType: [],
          licenseAvailable: [],
          licenseSelected: [],
          licenseApplied: '',
        }
      },
      components: {
        CheckReceivedOrderUpdateModal
      },
      methods: {
        getStatusIcon(status) {
          if (status == "SUCCESS") {
            return 'fa fa-check green_tick';
          } else {
            return 'fa fa-location-arrow red_tick';
          }
        },
        getPaymentStatus(isCheckReceivedFlag, paymentMethod) {
          if (paymentMethod == 'check') {
            return (isCheckReceivedFlag) ? 'Check Received' : 'Check Not Received';
          } else {
            return 'CC Purchase';
          }
        },
        getInvoicePdf(item) {
          axios('/getOrderInvoicePdf',
            {
              method: 'POST',
              data: {
                  "billing": {
                      "billing_name": item.billingName,
                      "billing_address": item.address,
                      "billing_city": item.city,
                      "billing_country": item.countryCode,
                      "billing_phone": item.phoneNumber,
                      "billing_state": item.stateCode,
                      "billing_zip": item.zipCode
                  },
                  "orderId": item.orderId
              }
            },
          )
          .then(response => {
            window.open(response.data.invoice_filepath, '_blank');
          })
          .catch(error => {
            console.log(error)
          });
        },
        showCheckOrderUpdateModal(orderId) {
          this.isCheckOrderUpdateModal = true;
          this.verrors.clear();
          this.updateOrderId = orderId;
        },
        closeCheckOrderUpdateModal() {
          this.isCheckOrderUpdateModal = false;
          this.verrors.clear();
          this.updateOrderId = '';
          this.checkReceived = '';
          this.checkNumber = '';
        },
       router_redirect: function(accountId) {
          let routeData = this.$router.resolve({name: 'accountlookupdetail', params: {account_id: accountId}});
          window.open(routeData.href, '_blank');
        },
        navigate(){
          this.$router.push(this.$router.currentRoute.fullPath)
          this.$router.go();
        },
        getStatusColor(status) {
            if (status == "Active") {
                return 'text_green';
            } else if(status == "Inactive") {
                return 'text_red';
            } else {
                return '';
            }
        },
        getSelectedAccountLicense() { 
          this.licenseSelected = [];         
          for(var i=0; i < this.enterprise_accounts.length; i++) {
              if(document.getElementById(this.enterprise_accounts[i].accountId).checked)
              {                
                var subscriptionSelected = { 'accountId': this.enterprise_accounts[i].accountId, 'UnitType': this.enterprise_accounts[i].unitType};
                this.licenseSelected.push(subscriptionSelected);
              }
          }
          
          axios('/enterprise/license_mapping/insert',
                    {
                    method: 'POST',
                    data:
                        {
                        licenses_applied: this.licenseSelected,
                        enterprise_id: this.accountId,
                        },
                    }
            )
            .then((resp) => {

            })
            .catch(error => {
            });
        }
      },
      created: function () {
        this.loading = true;
        
        axios.get('/enterprise/license-accounts/' + this.accountId, {
        })
        .then(response =>  {
            this.loading = false;
            this.enterprise_accounts = response.data;
        })
        .catch(function(error) {

        });

        axios.get('/enterprise/license-available/' + this.accountId, {
        })
        .then(response =>  {
            this.loading = false;
            this.licenseApplied = response.data.licenseApplied;
            this.licenseAvailable = response.data.orderItems;
            var subscriptionone =  { value: null, text: 'Please select' };
            this.unitType.push(subscriptionone);
           for(var i=0; i < response.data.orderItems.length; i++) {
             var subscription = {value: response.data.orderItems[i].subscriptionId, text: response.data.orderItems[i].unitType};
              this.unitType.push(subscription);
           }
        })
        .catch(function(error) {

        });
      }
    }

</script>
<style scoped>
.account_heading_1 { width: 3%; }
.account_heading_2 { width: 15%; }
.account_heading_3 { width: 15%; }
.account_heading_4 { width: 8%; }
.account_heading_5 { width: 8%; }
.account_heading_6 { width: 10%; }
.account_heading_7 { width: 13%; }
.account_heading_8 { width: 10%; }
.account_heading_9 { width: 10%; }
.account_heading_10 { width: 8%; }
.unit-wrapper {
    border: 1px solid #b6b6b6;
    border-top: none;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/enterprise_apply_licenses.vue